export const TRUCK_DEFAULTS = {
    heightIn: 162,
    widthIn: 102,
    lengthFt: 75,
    grossLb: 63000,
    tareLb: 33000,
    axles: 5,
    mpg: 6,
};
export const COST_PROFILE_DEFAULTS = {
    targetCentsPerMile: 40,
    floorCentsPerMile: 100,
};
//# sourceMappingURL=entities.js.map